import Image from 'next/image';
import styles from '../../styles/layout/footer.module.scss';

export default function Footer({ showSponsors = true }) {
  const sponsors = [
    { name: 'CloudFlare', logo: '/images/sponsors/cloudflare.png' },
    { name: 'Google', logo: '/images/sponsors/google.png' },
    { name: 'Telegram', logo: '/images/sponsors/tg.png' },
    { name: 'Twitter', logo: '/images/sponsors/x.png' },
    { name: 'Microsoft', logo: '/images/sponsors/microsoft.png' },
    { name: 'Adobe', logo: '/images/sponsors/adobe.png' },
    { name: 'Gemini', logo: '/images/sponsors/gemini.png' },
  ];

  return (
    <div className={styles.footerWrapper}>
      {/* Sponsors Section */}
      {showSponsors && (
        <div className={styles.sponsorsSection}>
          <div className='container'>
            <h2 className={styles.sponsorsTitle}>Backed by 30+ industry leaders</h2>
            <div className={styles.sponsorsLogos}>
              {sponsors.map((sponsor, index) => (
                <div key={index} className={styles.sponsorCard}>
                  <img src={sponsor.logo} alt={sponsor.name} className={styles.sponsorLogo} />
                </div>
              ))}
              {/* Repeat for carousel effect */}
              {sponsors.map((sponsor, index) => (
                <div key={`repeat-${index}`} className={styles.sponsorCard}>
                  <img src={sponsor.logo} alt={sponsor.name} className={styles.sponsorLogo} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Main Footer */}
      <footer className={styles.footer}>
        <div className='container'>
          {/* Top Section */}
          <div className={styles.topSection}>
            {/* Logo and Tagline */}
            <div className={styles.brandSection}>
              <div className={styles.logo}>
                <Image
                  src="/images/hero/union.svg"
                  alt="HFDX Logo Icon"
                  width={52}
                  height={25}
                  className={styles.logoIcon}
                />
                <span className={styles.logoText}>HFDX</span>
              </div>
              <div className={styles.tagline}>
                <p className={styles.taglineLarge}>Upgrade The Way You Build Wealth</p>
              </div>
            </div>

            {/* CTA Button */}
            <a href={process.env.NEXT_PUBLIC_APP_URL + '/sign-up'} className={styles.ctaButton}>
              <span>Start an account</span>
              <span className={styles.ctaIcon}>
                <div className={styles.arrowIconWrapper}>
                  <div className={styles.arrowIcon}>
                    <img
                      src="/images/hero/group-arrow.svg"
                      alt=""
                      role="presentation"
                    />
                  </div>
                </div>
              </span>
            </a>

          </div>

          {/* Links Section */}
          <div className={styles.linksSection}>
            <div className={styles.linksGroup}>
              {/* Company */}
              <div className={styles.linkColumn}>
                <h3 className={styles.linkTitle}>Company</h3>
                <a href="mailto:info@hfdx.xyz" className={styles.link}>Contact</a>
                <a href="/faqs" className={styles.link}>FAQ's</a>
                <a href="/docs" className={styles.link}>Docs</a>
              </div>

              {/* Products */}
              <div className={styles.linkColumn}>
                <h3 className={styles.linkTitle}>HFDX Products</h3>
                <a href="/invest" className={styles.link}>Invest Strategies</a>
                <a href={process.env.NEXT_PUBLIC_TRADE_URL} className={styles.link}>Crypto Perpetuals</a>
              </div>

              {/* Resources */}
              <div className={styles.linkColumn}>
                <h3 className={styles.linkTitle}>Resources</h3>
                <a href="/faqs" className={styles.link}>Help Center</a>
                <a href="/terms-and-conditions" className={styles.link}>Terms And Conditions</a>
                <a href="/privacy-policy" className={styles.link}>Privacy Policy</a>
                <a href="/cookies-policy" className={styles.link}>Cookies Policy</a>
                <a href="/risk-disclosure" className={styles.link}>Risk Disclosure</a>
              </div>
            </div>

            {/* Social */}
            <div className={styles.socialSection}>
              <h3 className={styles.linkTitle}>Follow us</h3>
              <div className={styles.socialIcons}>
                <a href={process.env.NEXT_PUBLIC_TELEGRAM_URL} className={styles.socialIcon} aria-label="Telegram">
                  <Image src="/images/social/telegram.svg" alt="Telegram" width={32} height={32} />
                </a>
                <a href={process.env.NEXT_PUBLIC_X_URL} className={styles.socialIcon} aria-label="Telegram">
                  <Image src="/images/social/twitter.svg" alt="Twitter" width={32} height={32} />
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className={styles.bottomSection}>
      
            <p className={styles.feedback}>
              If you wish to provide feedback on our service, please email us at info@hfdx.xyz
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
